<mat-expansion-panel
  class="damage-structure-card mb-2"
  [expanded]="expanded"
  (opened)="expanded = true"
  (closed)="expanded = false"
  [style.--card-border-color]="getFemaColor(damageStructure?.fema_classification)">

  <mat-expansion-panel-header class="pe-0">
    <mat-panel-title>
      {{ damageStructure?.primaryStructure ? "Primary Structure (#1)" : "Structure #" + index }}
    </mat-panel-title>
    @if (structure?.footPrint?.wkt) {
      <mat-panel-description (click)="$event.stopPropagation()">
        <button mat-icon-button [matMenuTriggerFor]="outerMenu" aria-label="Actions">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu panelClass="actions-menu" #outerMenu>
          <button mat-menu-item (click)="onZoomClick(structure.footPrint.wkt, 100)">
            <mat-icon svgIcon="send"></mat-icon>
            <span>Zoom to Structure</span>
          </button>
        </mat-menu>
      </mat-panel-description>
    }
  </mat-expansion-panel-header>

  <!-- ── Damage Assessment ─────────────────────────────────────── -->
  <mat-expansion-panel [expanded]="expanded">
    <mat-expansion-panel-header class="pe-0">
      <mat-panel-title>Damage Assessment</mat-panel-title>
      @if (structure?.roof_top_location?.wkt || structure?.footPrint?.wkt) {
        <mat-panel-description (click)="$event.stopPropagation()">
          <button mat-icon-button [matMenuTriggerFor]="damageMenu" aria-label="Actions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu panelClass="actions-menu" #damageMenu>
            @if (structure?.roof_top_location?.wkt) {
              <button mat-menu-item (click)="copyToClipboard(structure.roof_top_location.wkt)">
                <mat-icon>content_copy</mat-icon>
                <span>Copy Rooftop Point</span>
              </button>
            }
            @if (structure?.footPrint?.wkt) {
              <button mat-menu-item (click)="onZoomClick(structure.footPrint.wkt, 100)">
                <mat-icon svgIcon="send"></mat-icon>
                <span>Zoom to Structure</span>
              </button>
            }
          </mat-menu>
        </mat-panel-description>
      }
    </mat-expansion-panel-header>

    <div class="fema-assessment-card mb-2"
         [style.--score-color]="getFemaColor(damageStructure?.fema_classification)">

      <div class="fema-score-header px-3 py-2">
        <div class="fw-bold fs-5 text-white">{{ getFemaLabel(damageStructure?.fema_classification) }}</div>
        <div class="text-white" style="font-size: 0.7rem;">
          Approx. FEMA Score — {{ getFemaLevel(damageStructure?.fema_classification) ?? '–' }}/6
        </div>
        <div class="mt-1 text-white" style="font-size: 0.7rem;">
          <span class="fw-bold" style="font-size: 0.85rem;">{{ damageStructure?.catastrophe_score ?? '–' }}/100</span>
          Catastrophe score
        </div>
      </div>

      <div class="px-3 py-2">
        <div class="small fw-semibold pb-1">Roof Condition</div>

        @if (damageStructure?.roof_condition?.missing_material_percent != null) {
          <div class="d-flex justify-content-between align-items-center small">
            <span class="text-muted">Missing material</span>
            <div class="bar-row">
              <mat-progress-bar class="bar-percent" mode="determinate"
                [value]="damageStructure.roof_condition.missing_material_percent"
                [style.--bar-color]="getDsColor(damageStructure.roof_condition.missing_material_percent)">
              </mat-progress-bar>
              <span class="bar-percent-label">{{ damageStructure.roof_condition.missing_material_percent }}%</span>
            </div>
          </div>
        }
        @if (damageStructure?.roof_condition?.structural_damage_percent != null) {
          <div class="d-flex justify-content-between align-items-center small">
            <span class="text-muted">Structural damage</span>
            <div class="bar-row">
              <mat-progress-bar class="bar-percent" mode="determinate"
                [value]="damageStructure.roof_condition.structural_damage_percent"
                [style.--bar-color]="getDsColor(damageStructure.roof_condition.structural_damage_percent)">
              </mat-progress-bar>
              <span class="bar-percent-label">{{ damageStructure.roof_condition.structural_damage_percent }}%</span>
            </div>
          </div>
        }
        @if (damageStructure?.roof_condition?.tarp_percent != null) {
          <div class="d-flex justify-content-between align-items-center small">
            <span class="text-muted">Tarp coverage</span>
            <div class="bar-row">
              <mat-progress-bar class="bar-percent" mode="determinate"
                [value]="damageStructure.roof_condition.tarp_percent"
                [style.--bar-color]="getDsColor(damageStructure.roof_condition.tarp_percent)">
              </mat-progress-bar>
              <span class="bar-percent-label">{{ damageStructure.roof_condition.tarp_percent }}%</span>
            </div>
          </div>
        }
        @if (damageStructure?.roof_condition?.debris_percent != null) {
          <div class="d-flex justify-content-between align-items-center small">
            <span class="text-muted">Debris</span>
            <div class="bar-row">
              <mat-progress-bar class="bar-percent" mode="determinate"
                [value]="damageStructure.roof_condition.debris_percent"
                [style.--bar-color]="getDsColor(damageStructure.roof_condition.debris_percent)">
              </mat-progress-bar>
              <span class="bar-percent-label">{{ damageStructure.roof_condition.debris_percent }}%</span>
            </div>
          </div>
        }
        @if (damageStructure?.roof_condition?.discoloration?.percentage != null) {
          <div class="d-flex justify-content-between align-items-center small">
            <span class="text-muted">Discoloration</span>
            <div class="bar-row">
              <mat-progress-bar class="bar-percent" mode="determinate"
                [value]="damageStructure.roof_condition.discoloration.percentage"
                [style.--bar-color]="getDsColor(damageStructure.roof_condition.discoloration.percentage)">
              </mat-progress-bar>
              <span class="bar-percent-label">{{ damageStructure.roof_condition.discoloration.percentage }}%</span>
            </div>
          </div>
        }

      </div>
    </div>

  </mat-expansion-panel>

  <!-- ── Pre-Damage panels (use inherited `structure: IPropertyStructure`) ── -->
  @if (structure) {

    <!-- ── Pre-Damage Roof Info ──────────────────────────────────── -->
    <mat-expansion-panel class="mt-1" [expanded]="false">
      <mat-expansion-panel-header class="pe-0">
        <mat-panel-title class="me-0">Pre-Damage Roof Info</mat-panel-title>
        <mat-panel-description (click)="$event.stopPropagation()">
          <button mat-icon-button [matMenuTriggerFor]="roofMenu" aria-label="Actions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu panelClass="actions-menu" #roofMenu>
            @if (structure.roof_top_location?.wkt) {
              <button mat-menu-item (click)="copyToClipboard(structure.roof_top_location.wkt)">
                <mat-icon>content_copy</mat-icon>
                <span>Copy Rooftop Point</span>
              </button>
            }
            @if (structure.footPrint?.wkt) {
              <button mat-menu-item (click)="onZoomClick(structure.footPrint.wkt, 75)">
                <mat-icon svgIcon="send"></mat-icon>
                <span>Zoom to Structure</span>
              </button>
            }
          </mat-menu>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-card class="roof-score-card mb-2" [style.--score-color]="getRoofScoreColor(structure.roof_condition?.value)">
        <mat-card-content class="score-grid px-2 py-1">
          <div class="score-badge rounded px-2 py-1 text-center text-white align-self-center">
            <div class="fw-bold fs-5">{{ structure.roof_condition?.value ?? "-" }}</div>
            <div class="small">{{ getRoofScoreLabel(structure.roof_condition?.value) }}</div>
          </div>
          <div class="d-flex flex-column lh-sm" style="font-size:0.7rem;">
            <div class="d-flex justify-content-between">
              <span class="text-muted text-nowrap">Material</span>
              <span class="text-end text-capitalize text-black">{{ structure.roof_material?.class ?? "-" }}</span>
            </div>
            <div class="d-flex justify-content-between">
              <span class="text-muted text-nowrap">Shape</span>
              <span class="text-end text-capitalize text-black">{{ structure.roof_shape?.value ?? "-" }}</span>
            </div>
            <div class="d-flex justify-content-between">
              <span class="text-muted text-nowrap">Miss. mat.</span>
              <span class="text-end text-capitalize text-black">
                {{ structure.roof_condition_report?.["Missing Material"]?.percentage != null
                  ? structure.roof_condition_report["Missing Material"].percentage + "%"
                  : "None" }}
              </span>
            </div>
          </div>
          <div class="d-flex flex-column lh-sm ps-1" style="font-size:0.7rem;">
            <div class="d-flex justify-content-between">
              <span class="text-muted text-nowrap">Debris</span>
              <span class="text-end text-capitalize text-black">
                {{ structure.roof_condition_report?.debris?.percentage != null
                  ? structure.roof_condition_report.debris.percentage + "%" : "No" }}
              </span>
            </div>
            <div class="d-flex justify-content-between">
              <span class="text-muted text-nowrap">Discol.</span>
              <span class="text-end text-capitalize text-black">
                {{ structure.roof_condition_report?.discolorated?.percentage != null ? "Yes" : "No" }}
              </span>
            </div>
            <div class="d-flex justify-content-between">
              <span class="text-muted text-nowrap">Tarp</span>
              <span class="text-end text-capitalize text-black">
                {{ structure.roof_condition_report?.Tarp?.percentage != null
                  ? structure.roof_condition_report.Tarp.percentage + "%" : "None" }}
              </span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

    </mat-expansion-panel>

    <!-- ── Pre-Damage Structure Info ─────────────────────────────── -->
    <mat-expansion-panel class="mt-1" [expanded]="false">
      <mat-expansion-panel-header class="pe-0">
        <mat-panel-title class="me-0">Pre-Damage Structure Info</mat-panel-title>
        <mat-panel-description (click)="$event.stopPropagation()">
          <button mat-icon-button [matMenuTriggerFor]="structureMenu" aria-label="Actions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu panelClass="actions-menu" #structureMenu>
            @if (structure.footPrint?.wkt) {
              <button mat-menu-item (click)="copyToClipboard(structure.footPrint.wkt)">
                <mat-icon>content_copy</mat-icon>
                <span>Copy Footprint</span>
              </button>
            }
            @if (structure.footPrint?.wkt) {
              <button mat-menu-item (click)="onZoomClick(structure.footPrint.wkt, 100)">
                <mat-icon svgIcon="send"></mat-icon>
                <span>Zoom to Structure</span>
              </button>
            }
          </mat-menu>
        </mat-panel-description>
      </mat-expansion-panel-header>

      @if (structure.structure_info?.building_type) {
        <div class="d-flex justify-content-between align-items-center small">
          <span class="text-muted">Building Type</span>
          <span class="text-truncate">{{ formatBuildingType(structure.structure_info?.building_type) }}</span>
        </div>
      }
      @if (structure.footPrint?.area != null) {
        <div class="d-flex justify-content-between align-items-center small">
          <span class="text-muted">Footprint area</span>
          @if (structure.footPrint?.area) {<span>{{ formatArea(structure.footPrint?.area) }}</span>} @else {<span>–</span>}
        </div>
      }
      @if (structure.structure_info?.maximum_roof_height != null) {
        <div class="d-flex justify-content-between align-items-center small">
          <span class="text-muted">Max roof height</span>
          <span>{{ formatLength(structure.structure_info?.maximum_roof_height) }}</span>
        </div>
      }
      @if (structure.structure_info?.entrance_elevation != null) {
        <div class="d-flex justify-content-between align-items-center small">
          <span class="text-muted">Entrance elevation</span>
          <span>{{ formatLength(structure.structure_info?.entrance_elevation) }}</span>
        </div>
      }
      @if (structure.structure_info?.eave_height != null) {
        <div class="d-flex justify-content-between align-items-center small">
          <span class="text-muted">Eave height</span>
          <span>{{ formatLength(structure.structure_info?.eave_height) }}</span>
        </div>
      }
      @if (structure.structure_info?.number_of_stories_below_eave != null) {
        <div class="d-flex justify-content-between align-items-center small">
          <span class="text-muted">Est. # of stories</span>
          <span>{{ structure.structure_info?.number_of_stories_below_eave ?? 0 }}</span>
        </div>
      }
      <div class="d-flex justify-content-between align-items-center small">
        <span class="text-muted">Building Tree Cover</span>
        <div class="bar-row">
          <mat-progress-bar class="bar-percent" mode="determinate"
            [value]="structure.structure_info?.tree_cover">
          </mat-progress-bar>
          <span class="bar-percent-label">{{ structure.structure_info?.tree_cover ?? 0 }}%</span>
        </div>
      </div>

    </mat-expansion-panel>

    <!-- ── Pre-Damage Defensible Space ──────────────────────────── -->
    <mat-expansion-panel class="mt-1" [expanded]="false">
      <mat-expansion-panel-header class="pe-0">
        <mat-panel-title class="me-0">Pre-Damage Defensible Space</mat-panel-title>
        @if (parcelWkt) {
          <mat-panel-description (click)="$event.stopPropagation()">
            <button mat-icon-button [matMenuTriggerFor]="defSpaceMenu" aria-label="Actions">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu panelClass="actions-menu" #defSpaceMenu>
              <button mat-menu-item (click)="onZoomClick(parcelWkt, 100)">
                <mat-icon svgIcon="send"></mat-icon>
                <span>Zoom to Parcel</span>
              </button>
            </mat-menu>
          </mat-panel-description>
        }
      </mat-expansion-panel-header>

      <mat-table [dataSource]="getDefensibleSpaceBands(structure.defensible_space?.report)" class="w-100">
        <ng-container matColumnDef="label">
          <mat-header-cell *matHeaderCellDef class="small text-muted">Distance</mat-header-cell>
          <mat-cell *matCellDef="let band" class="small px-1 py-0">{{ band.label }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="treeCoverage">
          <mat-header-cell *matHeaderCellDef class="small text-muted">Tree Coverage</mat-header-cell>
          <mat-cell class="px-1 py-0" *matCellDef="let band">
            @if (band.t != null) {
              <div class="bar-row">
                <mat-progress-bar class="bar-percent" mode="determinate"
                  [value]="band.t" [style.--bar-color]="getDsColor(band.t)">
                </mat-progress-bar>
                <span class="bar-percent-label">{{ band.t | number: "1.0-0" }}%</span>
              </div>
            } @else {
              <span class="small text-muted">-</span>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="otherStructures">
          <mat-header-cell *matHeaderCellDef class="small text-muted">Other Structures</mat-header-cell>
          <mat-cell class="px-1 py-0" *matCellDef="let band">
            @if (band.b != null) {
              <div class="bar-row">
                <mat-progress-bar class="bar-percent" mode="determinate"
                  [value]="band.b" [style.--bar-color]="getDsColor(band.b)">
                </mat-progress-bar>
                <span class="bar-percent-label">{{ band.b | number: "1.0-0" }}%</span>
              </div>
            } @else {
              <span class="small text-muted">-</span>
            }
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="['label', 'treeCoverage', 'otherStructures']"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['label', 'treeCoverage', 'otherStructures']"></mat-row>
      </mat-table>

    </mat-expansion-panel>
  }

</mat-expansion-panel>
